function loadScript(url, options = {}) {
    const script = document.createElement('script');

    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', url);
    if (options.attributes) {
        options.attributes.forEach((attribute) => {
            script.setAttribute(attribute[0], attribute[1]);
        });
    }
    return new Promise((resolve, reject) => {
        const timerID = setTimeout(() => {
            console.error('script load timeout: ', url);
            if (options.noCatch) {
                resolve();
            } else {
                reject();
            }
        }, 10000);

        script.onload = () => {
            clearTimeout(timerID);
            resolve();
        };
        script.onerror = () => {
            clearTimeout(timerID);
            if (options.noCatch) {
                resolve();
            } else {
                reject();
            }
        };
        document.head.appendChild(script);
    });
}

export default loadScript;
